import React from "react";

const CLTVSummary = () => {
    return (
        <div className="bg-blue-50 dark:bg-gray-900 p-6 rounded-2xl shadow-md max-w-4xl mx-auto mt-10">
            <h2 className="text-2xl font-bold text-blue-900 dark:text-blue-200 mb-4">
                Customer Lifetime Value (CLTV) Summary
            </h2>

            <p className="text-gray-700 dark:text-gray-300 mb-6">
                The CLTV prediction model has been trained on a dataset of <strong>1,402,839 customers</strong>,
                with an average predicted CLTV of <strong>$29.21</strong>. The analysis window spans from
                <strong> January 1, 2021</strong>, to <strong>May 11, 2025</strong>.
            </p>

            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl border border-blue-100 dark:border-blue-800 mb-6">
                <h3 className="text-lg font-semibold text-blue-800 dark:text-blue-300 mb-2">🔍 Key Insights:</h3>
                <ul className="list-disc list-inside text-gray-800 dark:text-gray-200 space-y-2">
                    <li><strong>Top 10% of customers are highly valuable:</strong> Average predicted CLTV is <strong>$167.65</strong>.</li>
                    <li><strong>Model accuracy varies by decile:</strong> Accuracy improves in higher deciles.</li>
                    <li><strong>CLTV increases with decile:</strong> Higher deciles represent more valuable customers.</li>
                    <li><strong>Model underpredicts top deciles:</strong> Suggests model doesn’t fully capture behavior.</li>
                </ul>
            </div>

            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl border border-green-100 dark:border-green-800">
                <h3 className="text-lg font-semibold text-green-800 dark:text-green-300 mb-2">✅ Recommendations:</h3>
                <ul className="list-disc list-inside text-gray-800 dark:text-gray-200 space-y-2">
                    <li><strong>Focus on retaining top customers:</strong> Launch campaigns to retain the top 10%.</li>
                    <li><strong>Refine the model for top deciles:</strong> Improve model to capture high-value behavior.</li>
                    <li><strong>Use the model for budget allocation:</strong> Allocate resources based on CLTV.</li>
                    <li><strong>Monitor and adjust:</strong> Continuously track performance and strategies.</li>
                </ul>
            </div>
        </div>

    );
};

export default CLTVSummary;